import { mapFields } from './MapInputFields';

export const getEditorContent = (createmode, removeBorder, removeMargin) => {
  if (removeBorder) {
    const htmlData = mapFields(createmode, removeBorder, false, removeMargin);
    return htmlData;
  } else {
    const htmlData = mapFields(createmode);
    return htmlData;
  }
};
